import { render, staticRenderFns } from "./search.vue?vue&type=template&id=5923eec0&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"
import style0 from "./search.vue?vue&type=style&index=0&id=5923eec0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923eec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5923eec0')) {
      api.createRecord('5923eec0', component.options)
    } else {
      api.reload('5923eec0', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=5923eec0&scoped=true", function () {
      api.rerender('5923eec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/channelSecurity/components/search.vue"
export default component.exports